import React from "react";
import Profile from "../pages/Profile";
import Preview from "../pages/Preview";
import Skills from "../pages/Skills";
import Experience from "../pages/Experience";
import Projects from "../pages/Projects";
import Education from "../pages/Education";
import Certifications from "../pages/Certifications";
import Reporting from "../pages/admin/Reporting";
import Admin from "../pages/admin/Admin";
import Logout from "../pages/Logout";
import Dashboard from "../pages/Dashboard";
import AdminDashboard from "../pages/admin/AdminDashboard";

// todo implement redirect to home on unknown url / page refresh
const routes = [
    {
        path: "/",
        exact: true,
        main: () => <Dashboard />
    },
    {
        path: "/admindashboard",
        exact: true,
        main: () => <AdminDashboard />
    },
    {
        path: "/profile",
        main: () => <Profile />
    },
    {
        path: "/skills",
        main: () => <Skills />
    },
    {
        path: "/experience",
        main: () => <Experience />
    },
    {
        path: "/projects",
        main: () => <Projects />
    },
    {
        path: "/education",
        main: () => <Education />
    },
    {
        path: "/certifications",
        main: () => <Certifications />
    },
    {
        path: "/preview",
        main: () => <Preview />
    },
    {
        path: "/reporting",
        main: () => <Reporting />
    },
    {
        path: "/admin",
        main: () => <Admin />
    },
    {
        path: "/logout",
        main: () => <Logout />
    },
];

export default routes;